<template>
  <a-card style="margin: 10px" :bordered="false">
    <div class="table-page-search-wrapper" style="margin-bottom: 10px">
      <a-form layout="inline">
        <a-row :gutter="24">
          <a-col :md="6" :sm="18" >
            <a-form-item label="昵称"   :labelCol="labelCol"
                         :wrapperCol="wrapperCol">
              <a-input v-model="queryParam.nickName" placeholder=""/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="18">
            <a-form-item label="性别"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol">
              <a-select v-model="queryParam.sex" style="width: 150px">
                <a-select-option key="">全部</a-select-option>
                <a-select-option key="1">男</a-select-option>
                <a-select-option key="2">女</a-select-option>
                <a-select-option key="3">其他</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="18">
            <a-form-item label="用户类型"
                         :labelCol="labelCol"
                         :wrapperCol="wrapperCol">
              <a-select v-model="queryParam.relationType" style="width: 150px">
                <a-select-option key="">全部</a-select-option>
                <a-select-option key="user">用户</a-select-option>
                <a-select-option key="staff">员工</a-select-option>
                <a-select-option key="supplier">供应商</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="18" >
            <a-form-item label="销售员编号"   :labelCol="labelCol"
                         :wrapperCol="wrapperCol">
              <a-input v-model="queryParam.sellerNo" placeholder=""/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="18">
            <span class="table-page-search-submitButtons">
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button style="margin-left: 8px" @click="Reset()">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <s-table
      ref="table"
      size="default"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      showPagination="true"
    >
      <template slot="avatar" slot-scope="text, record">
        <img :src="text" alt="" style="width: 50px;height: 50px">
      </template>
      <template slot="action" slot-scope="text, record">
        <a @click="$refs.userAdd.edit(record)">详情</a>
        <a v-if="record.relationType == 'user'" @click="$refs.staffList.edit(record)">绑定销售</a>
        <a v-if="record.relationType == 'staff'" @click="$refs.staffList.unBind(record)">解绑</a>
        <!--<a @click="edit">编辑</a>-->
        <!--<a @click="$refs.orderView.view(record)">解绑</a>-->
      </template>
    </s-table>
    <user-add ref="userAdd" @ok="handleOk" />
    <staff-list ref="staffList" @ok="handleOk" />
  </a-card>

</template>
<script>
//  import reqwest from 'reqwest'
import {getAxios, postAxios} from '@/api/request'
import userAdd from './modules/userAdd'
import staffList from './modules/staffList'
import { STable, Ellipsis } from '@/components'
import Cookies from 'js-cookie'

  export default {
    name: 'user',
    components: {
      userAdd,
      STable,
      Ellipsis,
      staffList
    },
    data() {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 7 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        data: [],
        pagination: {},
        queryParam: {
          sex: '',
          name: '',
          nickName: '',
      relationType: ''
        },
        loading: false,
        columns: [
          {
            title: '用户账号',
            ellipsis: true,
            dataIndex: 'userNo'
          },
          {
            title: '头像',
            dataIndex: 'avatar',
            ellipsis: true,
            scopedSlots: { customRender: 'avatar' }
          },
          {
            title: '昵称',
            ellipsis: true,
            dataIndex: 'nickName'
          },
          {
            title: '性别',
            dataIndex: 'sex',
            ellipsis: true,
            customRender: (text, row, index) => {
              if (text === 1) {
                return '男'
              } else if (text === 2) {
                return '女'
              } else {
                return '其他'
              }
            }
          },
          {
            title: '关系类型',
            ellipsis: true,
            dataIndex: 'relationType',
            customRender: (text, row, index) => {
              if (text === 'user') {
                return '用户'
              } else if (text === 'staff') {
                return '员工'
              } else if (text === 'supplier') {
                return '供应商'
              } else {
                return '其他'
              }
            }
          },
          {
            title: '销售员编号',
            ellipsis: true,
            dataIndex: 'sellerNo'
          },
          {
            title: '注册时间',
            ellipsis: true,
            dataIndex: 'createTime',
            customRender: (text, row, index) => {
              return new Date(parseInt(text)).toLocaleDateString().replace(/\//g, "-")+ " " + new Date(parseInt(text)).toTimeString().substr(0, 8)
            }
          },
          {
            title: '最近登录',
            dataIndex: 'lastLoginTime',
            ellipsis: true,
            customRender: (text, row, index) => {
              return new Date(parseInt(text)).toLocaleDateString().replace(/\//g, "-")+ " " + new Date(parseInt(text)).toTimeString().substr(0, 8)
            }
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            ellipsis: true,
            scopedSlots: { customRender: 'action' }
          }
        ],
        // 加载数据方法 必须为 Promise 对象 county
        loadData: parameter => {
          const params = {}
          params.pageNo = parameter.pageNum
          params.pageSize = parameter.pageSize
          params.nickName = this.queryParam.nickName
          params.relationType = this.queryParam.relationType
          params.sex = this.queryParam.sex
          params.sellerNo = this.queryParam.sellerNo
          return postAxios('userList', params)
            .then(res => {
              const data = {}
//              res = res.data
              console.log(res)
              data.data = res.rows
              data.pageNum = parameter.pageNum
              data.totalCount = res.total
              return data
            })
        }
      }
    },
    mounted() {

    },
    methods: {
      handleOk () {
        this.$refs.table.refresh()
      },
      Reset() {
        this.queryParam.nickName = ''
        this.queryParam.relationType = ''
        this.queryParam.sex = ''
        this.queryParam.sellerNo = ''
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/userManage/user.vue